var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.939,
    height: 16.476,
    viewBox: "0 0 17.939 16.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-mark",
    transform: "translate(-31.92 461.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M47.388-461.881a23.937,23.937,0,0,0-2.614,1.922,47.572,47.572,0,0,0-6.538,6.73,8.12,8.12,0,0,1-.56.673c-.016,0-.9-.6-1.962-1.345s-1.966-1.369-2.01-1.4a.477.477,0,0,0-.216-.052c-.128,0-.2.064-.853.709-.881.881-.865.817-.4,1.449,2.134,2.943,4.364,6.177,5.016,7.278.16.276.252.388.352.436a.362.362,0,0,0,.42-.056c.032-.036.264-.412.512-.829a98.489,98.489,0,0,1,6.7-9.889,40.585,40.585,0,0,1,3.591-4.072c.969-.965,1.037-1.041,1.037-1.177a.345.345,0,0,0-.2-.356,3.838,3.838,0,0,0-1.149-.056A10.037,10.037,0,0,0,47.388-461.881Z",
    transform: "translate(0 0)",
    fill: "#1f1f1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.e9d8dd93a1a238a6c44689cd5ac733fc.svg";
export { ForwardRef as ReactComponent };